import { Box, styled } from '@mui/material';

export const ContainerHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingTop: '8px',
  paddingBottom: '8px',
  paddingLeft: '16px',
  backgroundColor: theme.palette.primary.dark,
}));
